<template>
    <transition name="modal-fade" v-if="isVisible">
        <div class="modal-overlay">
            <div class="modal-content hide-scrollbar" @click.stop >
                <div style="text-align:right; margin:8px -16px -40px 0; z-index:999;"><span class="material-icons" @click="$emit('close-modal')">close</span></div>
                <form class="row">

                    <div class="col-12 title">{{title}}</div>
                    <div class="box col-12 row">
                        <div class="col-12">
                            <label class="form-label">Sub-Contractor/Business Name</label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Name" placeholder="Business Name">
                        </div>

                        <div class="col-6">
                            <label class="form-label">First Name<span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.ContactFirstName" placeholder="First Name">
                        </div>
                        <div class="col-6">
                            <label class="form-label">Last Name<span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.ContactLastName" placeholder="Last Name">
                        </div>

                        <div class="col-8">
                            <label class="form-label">Address<span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Address" placeholder="Address">
                        </div>
                        <div class="col-4">
                            <label class="form-label">Unit</label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Unit" placeholder="Unit">
                        </div>

                        <div class="col-6 col-sm-6">
                            <label class="form-label">City<span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.City" placeholder="City">
                        </div>
                        <div class="col-6 col-sm-6">
                            <label class="form-label">Province<span class="mandatory">*</span></label>
                            <select class="form-select" v-model="PersonalInfo.Province">
                                <option value="">Please Select</option>
                                <option v-for="obj in $core.data.Provinces" :key="obj" :val="obj">{{obj}}</option>
                            </select>
                        </div>

                        <div class="col-6 col-sm-5">
                            <label class="form-label">Postal Code<span class="mandatory">*</span></label>
                            <input type="text" class="form-control" v-model="PersonalInfo.PostalCode" placeholder="Postal Code" maxlength="7">
                        </div>
                        <div class="col-6 col-sm-5">
                            <label class="form-label">Fax</label>
                            <input type="text" class="form-control" v-model="PersonalInfo.Fax" placeholder="Fax" pattern="\d*" maxlength="10">
                        </div>

                        <div class="col-6 col-sm-5">
                            <label class="form-label">Business Phone No. <span class="mandatory">*</span></label>
                            <input type="text" @input="filterNumbers" class="form-control" v-model="PersonalInfo.Phone" placeholder="Business Phone No."  maxlength="10">
                        </div>
                        <div class="col-3">
                            <label class="form-label">Ext</label>
                            <input type="number" class="form-control" v-model="PersonalInfo.PhoneExtension" placeholder="Ext">
                        </div>

                        <div class="col-12 col-sm-9">
                            <label class="form-label">Business Email <span class="mandatory">*</span></label>
                            <input type="email" class="form-control" v-model="PersonalInfo.Email" placeholder="Business Email">
                        </div>


                        <div class="col-12">
                            <p class="form-label sub-title">Alternate Contact Info</p>
                        </div>

                        <div class="col-12">
                            <div>
                                <label class="form-label col-3">Phone# </label>
                                <div class="form-check form-check-inline" style="display: none;">
                                    <input @change="samePhoneChange" type="checkbox" v-model="PersonalInfo.SamePhone" id="samePhone" class="form-check-input" />
                                    <label for="samePhone" class="form-check-label" style="font-size:12px; color: black; font-weight:400;">Same as business phone no above</label>
                                </div>
                            </div>
                            <div class="col-6 col-sm-5">
                                <input type="text" @input="filterNumbers" class="form-control col-6" v-model="PersonalInfo.ContactPhone" placeholder="Phone Number" pattern="\d*" maxlength="10">
                            </div>

                        </div>
                        <div class="col-12">
                            <div>
                                <label class="form-label col-3">Email </label>
                                <div class="form-check form-check-inline" style="display: none;">
                                    <input @change="sameEmailChange" type="checkbox" v-model="PersonalInfo.SameEmail" id="sameEmail" class="form-check-input" />
                                    <label for="sameEmail" class="form-check-label" style="font-size:12px; color: black; font-weight:400;">Same as business email above</label>
                                </div>
                            </div>
                            <div class="col-12 col-sm-9">
                                <input type="text" class="form-control" v-model="PersonalInfo.ContactEmail" placeholder="Email">
                            </div>

                        </div>

                    </div>
                     

                    <div class="col-12" style="text-align:right;">
                        <div class="btn btn-positive" @click="save">Save</div>
                    </div>


                </form>
                 
            </div>
            
        </div>
    </transition>

</template>

<script>
    export default {

        props: {
            visible: Boolean,
            data: Object
            
        },

        data() {
            return {
                PersonalInfo: this.data ? this.data : {Name:'', ContactFirstName: '', ContactLastName: '', ContactEmail: '', ContactPhone: '', Address: '', Unit: '', City: '', Province: '', PostalCode: '', Fax: '', Phone: '', PhoneExtension: '',SameEmail: false, SamePhone: false },
                title: "Business information",
                isVisible: this.visible, // Local visibility state

            }
        },
        mounted() {
            console.log();
        
        },
        watch: {
            visible(newVal) {
                this.isVisible = newVal; // Sync local state with prop changes
                 
                this.PersonalInfo = this.data ? this.data :  {Name:'', ContactFirstName: '', ContactLastName: '', ContactEmail: '', ContactPhone: '', Address: '', Unit: '', City: '', Province: '', PostalCode: '', Fax: '', Phone: '', PhoneExtension: '',SameEmail: false, SamePhone: false };
                 
            },
        },
        methods: {

            filterNumbers(event) {
                var phoneNumber = event.target.value.replace(/\D/g, "");     
                console.log("phoneNumber", phoneNumber);         
                event.target.value = phoneNumber;
            },
            dataUpdate(obj) {

                console.log("dataUpdate", JSON.stringify(obj));
                this.PersonalInfo = obj;
            },
      
            sameEmailChange() {
                if (this.PersonalInfo.SameEmail) {
                    this.PersonalInfo.ContactEmail = this.PersonalInfo.Email;
                }
            },
            samePhoneChange() {
                console.log("samePhoneChange", this.PersonalInfo.SamePhone);
                if (this.PersonalInfo.SamePhone) {
                    this.PersonalInfo.ContactPhone = this.PersonalInfo.Phone;
                }
            },

            save() {
                /*     
                if (!this.PersonalInfo.Name) {
                    this.$emit('alert', 'Please enter the business name');
                    return;
                }
                    */
                if (!this.PersonalInfo.ContactFirstName) {
                    this.$emit('alert', 'Please enter the first name');
                    return;
                }
                if (!this.PersonalInfo.ContactLastName) {
                    this.$emit('alert', 'Please enter the last name');
                    return;
                }
                if (!this.PersonalInfo.Address) {
                    this.$emit('alert', 'Please enter the address');
                    return;
                }
                if (!this.PersonalInfo.City) {
                    this.$emit('alert', 'Please enter the City');
                    return;
                }
                if (!this.PersonalInfo.PostalCode) {
                    this.$emit('alert', 'Please choose the Postal Code');
                    return;
                }
                if (!this.PersonalInfo.Province) {
                    this.$emit('alert', 'Please choose the Province');
                    return;
                }
                if (!this.PersonalInfo.Phone) {
                    this.$emit('alert', 'Please enter the phone number');
                    return;
                }
                if (!this.PersonalInfo.Email) {
                    this.$emit('alert', 'Please enter the email address');
                    return;
                }

                this.$emit('saveProfile', this.PersonalInfo);
            }

        }
    }
</script>

<style scoped>
    .modal-overlay {
        z-index:999;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000000da;
        max-width:100%;
    }

    .modal-content {
        background-color: white;
        height: fit-content;
        width: 500px;
        max-width: 90vh;
        max-height: 90vh;
        margin:auto;
        padding: 0px 24px;
        border-radius: 20px;
       
    }


   

    .check {
        width: 150px;
    }

   
    p {
        /* font-weight: 500; */
        font-size: 16px;
        margin: 20px 0;
    }

    button {
        background-color: #ac003e;
        width: 150px;
        height: 40px;
        color: white;
        font-size: 14px;
        border-radius: 16px;
        margin-top: 50px;
    }

    .modal-fade-enter,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity 0.5s ease;
    }

    .form-check-inline {
        margin: 4px 0px;
    }

    .form-check-label {
        vertical-align: middle;
    }

    .form-check-input {
        vertical-align: middle;
    }
</style>